<template>
  <path
    d="M6 15.0002C6.56 15.0002 7 14.5502 7 14.0002V8.41024L17.89 19.3002C18.28 19.6902 18.91 19.6902 19.3 19.3002C19.69 18.9102 19.69 18.2802 19.3 17.8902L8.41 7.00024H14C14.55 7.00024 15 6.55024 15 6.00024C15 5.45024 14.55 5.00024 14 5.00024H6C5.45 5.00024 5 5.45024 5 6.00024V14.0002C5 14.5502 5.45 15.0002 6 15.0002Z"
  />
</template>
